var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workbench-box"},[_c('div',{staticClass:"workbench-container"},[_c('workbench-chat',{key:_vm.num})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }